import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import { StokkieLogo } from "@/features/stokvel/StokkieLogo";

/**
 * "Register as a Stokvel" — the second path off the one sign-in page (§4.1),
 * under Stokkie Stokvel's own name.
 *
 * Under the shop invite rather than inside the card: the card is a till's
 * keypad and a back office's email form, and a stokvel member needs neither.
 * They have a cellphone number, and that is all this asks for.
 */
export function StokvelInvite() {
  return (
    <aside
      aria-labelledby="stokvel-invite-title"
      className="w-full rounded-[1.375rem] bg-surface p-5 shadow-pop"
    >
      <StokkieLogo className="mx-auto w-full max-w-[13rem]" />
      <p
        id="stokvel-invite-title"
        className="mt-2 text-center text-xs text-ink-500"
      >
        In a stokvel? Start or join one with your cellphone number.
      </p>

      <Link
        to="/stokvel/start"
        className="mt-3 inline-flex h-touch-lg w-full items-center justify-center gap-2 rounded-control border border-brand-500 px-4 text-sm font-semibold text-brand-500 transition-colors hover:bg-brand-500/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/40"
      >
        Go to Stokkie Stokvel
        <ArrowRight className="size-4" aria-hidden />
      </Link>
      <Link
        to="/stokkie"
        className="mt-2 block text-center text-xs font-medium text-brand-500 hover:underline"
      >
        What is Stokkie Stokvel?
      </Link>
    </aside>
  );
}
